import React, { useState } from 'react'
import { PageContainer } from 'src/component/page-container/page-container'
import { BackArrow } from 'src/component/programmes/programme-back-arrow'
import { WorkoutPopup } from 'src/component/programmes/programme-workout-popup'
import { Grid } from 'src/component/ui/grid/grid'
import { PageTitle } from 'src/component/ui/page-title'
import { Workout, WorkoutCard } from 'src/component/ui/workout-card'
import { WorkoutCardSkeleton } from 'src/component/ui/workout-card/workout-card-skeleton'
import { useCompletedWorkouts } from 'src/hook/use-workouts'
import { toasterUtil } from 'src/util/toaster-util'

export const CompletedWorkoutsScreen = (): React.ReactElement => {
  const [selectedWorkout, setSelectedWorkout] = useState<Workout | undefined>(undefined)

  const {
    data: completedWorkoutsData = [],
    isLoading,
    isError,
  } = useCompletedWorkouts(
    {
      orderField: 'completedAt',
      orderDirection: 'DESC',
    },
    {
      onError: () => {
        toasterUtil.error('We are having difficulties loading your completed workouts, please try again.')
      },
    },
  )

  const completedWorkouts = completedWorkoutsData?.map((cw) => cw.workout) || []

  return (
    <PageContainer>
      <div className="py-6 md:py-[82px]">
        <div className="mb-10">
          <BackArrow />
        </div>
        <div className="mb-10">
          <PageTitle>Completed Workouts</PageTitle>
        </div>
        {isLoading || isError ? (
          <Grid.Skeleton count={6}>
            <WorkoutCardSkeleton />
          </Grid.Skeleton>
        ) : (
          <Grid
            items={completedWorkouts}
            keyExtractor={(w) => w.id}
            renderItem={(workout) => (
              <WorkoutCard.List workout={workout} isCompleted={true} onAction={() => setSelectedWorkout(workout)} />
            )}
          ></Grid>
        )}
      </div>
      <WorkoutPopup
        setOnClose={() => setSelectedWorkout(undefined)}
        selectedWorkout={selectedWorkout}
        startWorkoutLink={selectedWorkout ? `/workouts/${selectedWorkout?.id}` : undefined}
      />
    </PageContainer>
  )
}
